import { memo } from 'react';
import { MandatoryFilter } from 'src/modules/common/constants';
import { Filter } from 'src/utils/composeFilter';
import { HomePageData } from 'src/modules/home/HomePageMapping';
import { RegionsEnum } from 'src/generated/operations.ts';
import { mappingAM, mappingEU } from 'src/modules/home/ValveTypesMapping.ts';
import { HomeValve } from './HomeValve';

type Props = {
    region: RegionsEnum;
    homePageData: HomePageData;
    filter: Filter;
    userFilter: Filter;
    isRevit6WayFiltered: boolean;
    checkboxHandler: (detail: { name: string; value: string | string[] }) => void;
}

export const HomeValves = memo(({
    region,
    homePageData,
    filter,
    userFilter,
    isRevit6WayFiltered,
    checkboxHandler,
}: Props) => {
    const ShortValveTypeToImageMapping = region === RegionsEnum.Am ? mappingAM : mappingEU;
    const name = MandatoryFilter.ValveType;

    const shortValveTypeValues = homePageData[`raw_${name}` as keyof HomePageData];
    const shortValveTypeValuesAvailable = homePageData[name as keyof HomePageData].values.map((v) => v.value);
    const valuesAutoSelected = filter[name] || [];
    const valuesSelectedByUser = userFilter[name] || [];

    return (
        <div className="vss-home-valves__column">
            {ShortValveTypeToImageMapping.map(({ image, type }) => {
                const item = shortValveTypeValues.values.find(({ value }) => value === type);

                if (item === undefined) {
                    return null;
                }

                if (isRevit6WayFiltered && type.includes('6-way')) {
                    return null;
                }

                const checked = valuesAutoSelected.includes(type);
                const isNotSelected = !valuesSelectedByUser.includes(type);
                const allowed = !isNotSelected ||
                    (!checked && shortValveTypeValuesAvailable.includes(type));

                return (
                    <HomeValve
                        key={type}
                        name={type}
                        title={item.label}
                        imageURL={image}
                        checked={checked}
                        disabled={!allowed}
                        isSingleVariant={checked && isNotSelected}
                        onChange={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            checkboxHandler({ name, value: type });
                        }}
                    />
                );
            })}
        </div>
    );
});
